// Wroot Beehive Monitoring - Consistent Color Theme

export const beehiveTheme = {
  // Primary Colors
  primary: {
    main: '#1a1a1a',      // Deep black for text
    light: '#2d2d2d',     // Lighter black for hover states
    dark: '#000000',      // Pure black
  },
  
  // Accent Color (Honey Gold)
  accent: {
    main: '#F59E0B',      // Warm gold
    light: '#FDB813',     // Bright gold
    dark: '#D97706',      // Deep gold
  },
  
  // Neutral Colors
  neutral: {
    white: '#ffffff',
    offWhite: '#f9fafb',
    lightGray: '#e5e7eb',
    gray: '#9ca3af',
    darkGray: '#4b5563',
  },
  
  // Semantic Colors
  success: '#10b981',
  error: '#ef4444',
  warning: '#f59e0b',
  info: '#3b82f6',
  
  // Gradients
  gradients: {
    primary: 'linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%)',
    accent: 'linear-gradient(135deg, #F59E0B 0%, #D97706 100%)',
    subtle: 'linear-gradient(135deg, #f9fafb 0%, #ffffff 100%)',
  },
  
  // Shadows
  shadows: {
    sm: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
    md: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
    lg: '0 10px 15px -3px rgba(0, 0, 0, 0.1)',
    xl: '0 20px 25px -5px rgba(0, 0, 0, 0.1)',
  },
  
  // Typography
  typography: {
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    h1: {
      fontSize: '3.5rem',
      fontWeight: 700,
      lineHeight: 1.2,
    },
    h2: {
      fontSize: '2.5rem',
      fontWeight: 700,
      lineHeight: 1.3,
    },
    h3: {
      fontSize: '2rem',
      fontWeight: 600,
      lineHeight: 1.4,
    },
    body: {
      fontSize: '1rem',
      lineHeight: 1.7,
    },
  },
};

export default beehiveTheme;
